import C5StaticData from "@/pages/c5/C5StaticData/main";
import C5TimeSeries from "@/pages/c5/C5TimeSeries/main";
import C5Transactions from "@/pages/c5/C5Transactions/main";
import C5Events from "@/pages/c5/C5Events/main";
import { Route, Routes } from "react-router-dom";
import C5DownloadCenter from "./C5DownloadCenter/main";
import C5Issuers from "./C5Issuers/main";
import C5PdfPageSelection from "./C5PdfPageSelection/main";
import C5Portfolios from "./C5Portfolios/main";
import C5DataUpload from "./C5DataUpload/main";
import C5BankPositions from "./C5BankPositions/main";

export default function C5Routes() {
  return (
    <Routes>
      <Route path="c5_events/*" element={<C5Events />} />
      <Route path="c5_static_data/*" element={<C5StaticData />} />
      <Route path="c5_time_series/*" element={<C5TimeSeries />} />
      <Route path="c5_transactions/*" element={<C5Transactions />} />
      <Route path="c5_bank_positions/*" element={<C5BankPositions />} />
      <Route path="c5_portfolios/*" element={<C5Portfolios />} />
      <Route path="c5_issuers/*" element={<C5Issuers />} />
      <Route path="c5_pdf_page_selection/*" element={<C5PdfPageSelection />} />
      <Route path="c5_download_center/*" element={<C5DownloadCenter />} />
      <Route path="c5_data_upload/*" element={<C5DataUpload />} />
    </Routes>
  );
}
